import React from "react";

const Home = () => {
  return (
    <div style={{ padding: "20px" }}>
      <h2>Welcome to MarketBot</h2>
      <p>Manage your listings and campaigns with ease.</p>

      <a
        href="https://github.com/shuggins1984/MarketBot/blob/main/MarketBot_Installer.exe"
        download
        style={{
          display: "inline-block",
          marginTop: "20px",
          padding: "12px 20px",
          backgroundColor: "#007bff",
          color: "#fff",
          textDecoration: "none",
          borderRadius: "5px",
          fontWeight: "bold"
        }}
      >
        ⬇️ Download MarketBot Installer
      </a>
    </div>
  );
};

export default Home;
